import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const MenuS2: React.FC<Props> = ({ accessibilityLabel, className }) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      {...iconAccessibility(accessibilityLabel)}
    >
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill='currentColor'
          d='M17 7.25v1.5H7v-1.5h10zm-10 5.5h10v-1.5H7v1.5zm0 4h10v-1.5H7v1.5z'
        />
      </g>
    </svg>
  </i>
);

MenuS2.displayName = 'MenuS2';
export default MenuS2;
